<button class="btn btn-info btn-sm no-print" (click)="downloadPDF()">
  Export to PDF&nbsp;<i class="fa fa-file-pdf"></i>
</button>